import { DropdownModule } from 'primeng/dropdown';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ITableModule } from '@devinforius/i-table';
import { SuperComposLib } from '@devinforius/super-compos-17';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TogglerComponent } from './components/toggler/toggler.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MeetingSmallCardComponent } from './components/meeting-small-card/meeting-small-card.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { UsersNContactsComponent } from './components/users-n-contacts/users-n-contacts.component';
import { LayoutTogglerComponent } from './components/layout-toggler/layout-toggler.component';
import { TableColumnsFilterComponent } from './components/table-columns-filter/table-columns-filter.component';
import { ChipsModule } from 'primeng/chips';
import { RoundedButtonComponent } from './components/rounded-button/rounded-button.component';
import { InfosChipComponent } from './components/infos-chip/infos-chip.component';
import { IDxEditorModule } from '@devinforius/i-dx-editor';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { ButtonsGroupComponent } from './components/buttons-group/buttons-group.component';
import { CheckableListComponent } from './components/checkable-list/checkable-list.component';
import { CheckboxModule } from 'primeng/checkbox';
import { RecipientsNActionsComponent } from './components/recipents-n-actions/recipients-n-actions.component';
import { ActionCardComponent } from '../modules/private/pages/actions/action-card/action-card.component';
import { AddActionFormComponent } from '../modules/private/pages/actions/add-action-form/add-action-form.component';
import { INavigationModule } from '@devinforius/i-navigation';
import { ActionProcessComponent } from '../modules/private/pages/actions/action-process/action-process.component';
import { MessageModule } from 'primeng/message';
import { RecipientCardComponent } from './components/recipient-card/recipient-card.component';
import { EmptyResultPlaceholderComponent } from './components/empty-result-placeholder/empty-result-placeholder.component';
import { StatusPillComponent } from './components/status-pill/status-pill.component';
import { BasicBadgeComponent } from './components/basic-badge/basic-badge.component';
import { DocumentsNFilesComponent } from './components/documents-n-files/documents-n-files.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { IViewerModule } from '@devinforius/i-viewer';
import { InputMaskModule } from 'primeng/inputmask';
import { DeleteIconComponent } from './components/delete-icon/delete-icon.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DeleteButtonComponent } from './components/buttons/delete-button/delete-button.component';
import { CancelButtonComponent } from './components/buttons/cancel-button/cancel-button.component';
import { CreateButtonComponent } from './components/buttons/create-button/create-button.component';
import { BasicTableComponent } from './components/basic-table/basic-table.component';

@NgModule({
  declarations: [
    TogglerComponent,
    ConfirmDialogComponent,
    MeetingSmallCardComponent,
    UsersNContactsComponent,
    LayoutTogglerComponent,
    TableColumnsFilterComponent,
    RoundedButtonComponent,
    InfosChipComponent,
    FormErrorComponent,
    ButtonsGroupComponent,
    CheckableListComponent,
    RecipientsNActionsComponent,
    ActionCardComponent,
    ActionProcessComponent,
    AddActionFormComponent,
    RecipientCardComponent,
    EmptyResultPlaceholderComponent,
    StatusPillComponent,

    BasicBadgeComponent,
    DocumentsNFilesComponent,
    DeleteIconComponent,
    DeleteButtonComponent,
    CancelButtonComponent,
    CreateButtonComponent,
    BasicTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IEssentialsModule,
    INavigationModule,
    SuperComposLib,
    HttpClientModule,
    DragDropModule,
    ReactiveFormsModule,
    DialogModule,
    TooltipModule,
    DropdownModule,
    MultiSelectModule,
    ITableModule,
    CalendarModule,
    ChipsModule,
    IDxEditorModule,
    CheckboxModule,
    MessageModule,
    InputSwitchModule,
    InputNumberModule,
    IEssentialsModule,
    IViewerModule,
    InputMaskModule,
    RadioButtonModule,
    OverlayPanelModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    IEssentialsModule,
    SuperComposLib,
    HttpClientModule,
    DragDropModule,
    ReactiveFormsModule,
    DialogModule,
    TooltipModule,
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    IDxEditorModule,
    CheckboxModule,
    RadioButtonModule,
    InputMaskModule,
    OverlayPanelModule,

    TogglerComponent,
    ConfirmDialogComponent,
    MeetingSmallCardComponent,
    UsersNContactsComponent,
    LayoutTogglerComponent,
    TableColumnsFilterComponent,
    RoundedButtonComponent,
    InfosChipComponent,
    FormErrorComponent,
    ButtonsGroupComponent,
    CheckableListComponent,
    RecipientsNActionsComponent,
    ActionCardComponent,
    AddActionFormComponent,
    ActionProcessComponent,
    RecipientCardComponent,
    EmptyResultPlaceholderComponent,
    StatusPillComponent,
    BasicBadgeComponent,
    DocumentsNFilesComponent,
    DeleteIconComponent,
    DeleteButtonComponent,
    CancelButtonComponent,
    CreateButtonComponent,
    BasicTableComponent,
  ],
})
export class SharedModule {}
